/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
/* eslint-disable max-len */
// /* eslint-disable indent */
// /* eslint-disable max-len */
import React, { useCallback, useEffect, useState, useContext } from "react"
import TopHeader from "../../components/TopHeader"
import { motion } from 'framer-motion'
import { Link } from "react-router-dom"
import moment from "moment"
import { dataService } from "../../services/data.services"
import { useParams, useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { useSelector ,useDispatch} from 'react-redux'
import CustomOverLay from "../../components/CustomOverLay"
import GlobalContext from "../../components/Context/GloablContext"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import formatMobileNumber from "../../CommonMethods/FormatMobileNumber"
import { convertEpochToDateFormat } from "../../CommonMethods/convertEpochToDateFormat"
import { useViewObserverQuery } from "../../slices/observerSlice"
import { handleEditMessageSent, handleSystemConfig } from "../../redux/systemConfigSlice"
import HelpGuideModal from '../../components/HelpGuideModal'
import {useGetHelpGuideOrganizationQuery} from '../../slices/patientSlice'
import OtpPreferenceList from "../../components/OtpPreferenceList"
import { organizationusersList } from "../../slices/apiSlice"
import { resetOrgUserSearch } from "../../redux/orgUserSearchSlice"

export default function ViewObserver() {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const location = useLocation();
    const dispatch = useDispatch()
    const auth = useSelector(state => state.auth)
    const {isSideBar,sendMessageToStartEditing,editSocket,setToastErrorMessage,setIsAdvancedSearchOpen} = useContext(GlobalContext)
    const [viewObserverDetails, setViewObserverDetails] = useState("");
    const [loading, setLoading] = useState(true)
    const dateformat = useSelector(state => state.systemConfigData.globalVariables.date_format)
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)
    const { id } = useParams()
    const { data, isFetching, status } = useViewObserverQuery(id, { refetchOnMountOrArgChange: true })
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const userType = sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideOrganizationQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    useEffect(() => {
        if (data !== undefined) {
            setViewObserverDetails(data[0])
        }
    }, [data])
    
    const handleEditButtonClick = () =>{
        if(!messageSent){
            sendMessageToStartEditing(viewObserverDetails?.user_id)
            let message
            editSocket.onmessage = (event) =>{
                message = event.data
                if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                    dispatch(organizationusersList.util.resetApiState())
                    navigate(`/manage-observer/edit-observer/${id}`,{state:{ ...location.state, fromScreen: 'view',true:true,id:id} })
                    dispatch(resetOrgUserSearch())
                    setIsAdvancedSearchOpen(false);
                } else{
                    dispatch(handleEditMessageSent(false))
                    { (JSON.parse(message)?.adminId) &&
                        setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this observer`)
                    }
                }
            }    
        }
    }   
    useEffect(() => {
        if (userType === 'admin') {
            setQueryParamsorg('type=org-view-observer');
        } else {
            setQueryParamsorg('type=org-user-view-observer');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await dataService.GetAPI(`system-configuration/`);
                dispatch(handleSystemConfig(response.data.data))
            } catch (error) {
                console.error("Error fetching data:", error);
            } 
        };
        fetchData();
    }, []);

    const date = convertEpochToDateFormat(viewObserverDetails?.created_at, dateformat)    
    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Observer"} />
                {/* isFetching&&status!=="fulfilled" */}
                {isFetching && status !== "fulfilled" ? <CustomOverLay Active text="Loading Observer Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'system_config_overlay'}`} /> : status === "rejected" ? <SearchEmptyScreen text={"No data found"} /> : <>

                    <div className='bg-white rounded-lg py-[12px] px-[30px] h-customh3'>
                        <motion.div
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className='bg-white'>
                                <div className='flex items-center mb-[22px]'>
                                    <Link to="/manage-observer" state={Array.isArray(location.state) ? '' : location.state}>
                                        <h1 className="text-sm font-normal text-[#52555D]">List of Observers</h1>
                                    </Link>
                                    <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>

                                    <h1 className="text-sm font-normal text-[#008586]">View Observer</h1>
                                    <span   onClick={() => setHelpGuideModel(true)} className=' ml-auto cursor-pointer'>
                                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                    </span> 

                                </div>
                                <div className="flex items-center pb-3 pr-9">
                                    <Link to={`/manage-observer`} state={Array.isArray(location.state) ? '' : location.state} className='flex items-center min-w-max z-[99]'>
                                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                        <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                    </Link>
                                    <h1 className='text-xl font-normal text-[#000000] text-center w-full xl:-ml-[146px]'>
                                        View Observer
                                    </h1>
                                    <div className="xl:hidden block">
                                        <button onClick={handleEditButtonClick}  id="edit" type='button' className={`min-w-max px-4 py-2 border border-[#972E4C] hover:bg-[#EDD7E1]  h-fit rounded-[16px] flex items-center ml-4`}>
                                            <span className='w-5'><img src="/images/edit_icon.svg" alt="icon" /></span>
                                            <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between items-center pl-[30px] xl:pr-11 pr-10">
                                        <div className="flex items-center">
                                            <p className="text-xl font-semibold text-[#000000]">{viewObserverDetails?.last_name} {viewObserverDetails?.first_name} </p>
                                            <p className="text-sm font-normal text-[#000000] px-2">{viewObserverDetails?.user_id}</p>
                                            {viewObserverDetails?.status == 'inactive' ? <p className="px-3 py-1.5 bg-[#C5C9DA] rounded-[16px] text-sm font-semibold text-[#52555D]">Inactive</p> :
                                                <p className="px-3 py-1.5 bg-[#CCE7E7] rounded-[16px] text-sm font-semibold text-[#006A6B]">Active</p>
                                            }
                                        </div>
                                        <div className="flex items-center">
                                            <button id="view_activity_log" type="button"
                                                onClick={() => { navigate('/manage-observer/activity_history', { state: [viewObserverDetails.user_name, true, id] }) ;dispatch(resetOrgUserSearch());
                                                setIsAdvancedSearchOpen(false);}}
                                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] 
                                        rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E] min-w-max
                                            focus:bg-[#863B50] disabled:bg-[#777C88] xl:mr-4 ml-2`}>
                                                View Activity Log
                                            </button>
                                            <div className="xl:block hidden">
                                                <button onClick={handleEditButtonClick}  id="edit" type='button' className={`min-w-max px-4 py-2.5 border border-[#972E4C] hover:bg-[#EDD7E1]  h-fit rounded-[16px] flex items-center`}>
                                                    <span className='w-5'><img src="/images/edit_icon.svg" alt="icon" /></span>
                                                    <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="h-customh17 overflow-auto scrollbar_purple pr-2.5 mt-[26px]">
                                        <div className="w-full px-6">
                                            <div className="bg-[#E7EAF4] rounded-lg p-6">
                                                <div className="flex -mx-1 flex-wrap">
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Username</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewObserverDetails?.user_name}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-2/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <div className="flex flex-wrap gap-x-12 gap-y-3 pt-2">
                                                                {/* Alerts by SMS */}
                                                                <div className="flex flex-col gap-2">
                                                                    <p className="text-sm font-normal text-[#000000]">Alerts by SMS</p>
                                                                    <span className={`inline-flex items-center justify-center text-sm font-normal ${viewObserverDetails?.sms_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                                                        {viewObserverDetails?.sms_alert === true ? "ON" : "OFF"}
                                                                    </span>
                                                                </div>
                                                                
                                                                {/* Alerts by Email */}
                                                                <div className="flex flex-col gap-2">
                                                                    <p className="text-sm font-normal text-[#000000]">Alerts by Email</p>
                                                                    <span className={`inline-flex items-center justify-center text-sm font-normal ${viewObserverDetails?.email_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                                                        {viewObserverDetails?.email_alert === true ? "ON" : "OFF"}
                                                                    </span>
                                                                </div>
                                                                
                                                                {/* Include Missed Readings */}
                                                                <div className="flex flex-col gap-2">
                                                                    <p className="text-sm font-normal text-[#000000]">Include Missed Readings</p>
                                                                    <span className={`inline-flex items-center justify-center text-sm font-normal ${viewObserverDetails?.missed_reading_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                                                        {viewObserverDetails?.missed_reading_alert === true ? "ON" : "OFF"}
                                                                    </span>
                                                                </div>
                                                                
                                                                {/* Receive readings acknowledgement */}
                                                                <div className="flex flex-col gap-2">
                                                                    <p className="text-sm font-normal text-[#000000]">Receive readings acknowledgement</p>
                                                                    <span className={`inline-flex items-center justify-center text-sm font-normal ${viewObserverDetails?.reading_received_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                                                        {viewObserverDetails?.reading_received_alert === true ? "ON" : "OFF"}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Email Address</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewObserverDetails?.email_address !== "" ? viewObserverDetails?.email_address : '-'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                            <p id={'mobile_no'} className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewObserverDetails?.mobile_number !== "" ? viewObserverDetails.mobile_country_code + "\t" + formatMobileNumber(viewObserverDetails?.mobile_number) : "-"}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Main Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewObserverDetails.main_country_code} {formatMobileNumber(viewObserverDetails.main_number)}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-2/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Address</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewObserverDetails.address !== "" ? viewObserverDetails.address : '-'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Created Date</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {date}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                           
                                            {<div className="bg-[#E7EAF4] rounded-lg p-6 mt-6">
                                                <div className="flex -mx-1 flex-wrap">
                                                    {/* <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Organization Name</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewObserverDetails?.organization_name !== undefined && viewObserverDetails?.organization_name !== "" 
                                                                    ? viewObserverDetails?.organization_name 
                                                                    : '-'}
                                                            </p>
                                                        </div>
                                                    </div> */}
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Sub Division Name</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewObserverDetails?.subdivision_name !== undefined && viewObserverDetails?.subdivision_name !== ""
                                                                    ? viewObserverDetails?.subdivision_name
                                                                    : '-'}
                                                            </p>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                             {/* otp preference list */}
                                             {viewObserverDetails?.user_name && 
                                                <OtpPreferenceList
                                                    username={viewObserverDetails?.user_name}
                                                    user_type={'observer'}

                                                />
                                            }
                                            {data[0]?.patient_id !== undefined && <div>
                                                <p className=' pt-2.5 min-w-fit text-base font-semibold text-[#972E4C] relative mt-5 mb-5'>
                                                    Patient Details
                                                </p>
                                                <div className='border border-[#EDD7E1] rounded-lg flex flex-col p-4  mt-3'>
                                                    <div className='flex xl:gap-[60px] gap-[10px]'>
                                                        <div>
                                                            <div>
                                                                <p className='mb-2'>Patient ID</p>
                                                                <p className='mb-6 text-[#031624]'>{data[0]?.patient_id}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>First Name</p>
                                                                <p className='mb-6 text-[#031624]' style={{ lineBreak: "anywhere" }}>{data[0]?.patient_first_name}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>Date of Birth</p>
                                                                <p className='mb-6 text-[#031624]'>{data[0]?.patient_date_of_birth}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>Primary Identifier</p>
                                                                <p className='mb-6 text-[#031624]'>{data[0]?.patient_primary_identifier}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>Email Address</p>
                                                                <p className='mb-6 text-[#031624]'>{data[0]?.patient_email_address}</p>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div>
                                                                <p className='mb-2'>Username</p>
                                                                <p className='mb-6 text-[#031624]'>{data[0]?.patient_user_name}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>Middle Name</p>
                                                                <p className='mb-6 text-[#031624]' style={{ lineBreak: "anywhere" }}>{data[0]?.patient_middle_name !== '' ? data[0]?.patient_middle_name : '-'}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>Age</p>
                                                                <p className='mb-6 text-[#031624]'>{data[0]?.patient_age}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>Secondary Identifier</p>
                                                                <p className='mb-6 text-[#031624]'>{data[0]?.patient_secondary_identifier !== '' ? data[0]?.patient_secondary_identifier : '-'}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'></p>
                                                                <p className='mb-6 text-[#031624]'></p>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div>
                                                                <p className='mb-2'></p>
                                                                <p className='mb-[80px]'></p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>Last Name</p>
                                                                <p className='mb-6 text-[#031624]' style={{ lineBreak: "anywhere" }}>{data[0]?.patient_last_name}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {(helpGuideModel && helpguidestatus==="fulfilled") &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }

                        </motion.div>
                    </div>


                </>}
            </div>
        </>
    )
}